'use strict';/* global define, console */define('modules/admin/states/admin/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
       controller.$inject = ["appConfig", "roleCheck", "me", "ADMIN_PANEL_MENU", "ROLES", "_"];
function controller(appConfig,roleCheck,me,ADMIN_PANEL_MENU,ROLES,_){// jshint validthis:true
// jshint latedef:false
var ctrl=this;var filterFns={deactivatedSections:_filterByDeactivateSections,companyAdmin:_filterByCompanyAdminRole,teamAdmin:_filterByTeamAdminRole};this.me=me;ctrl.conditions=getConditions(appConfig,me);ctrl.adminPanelMenu=getAdminMenuItems(ADMIN_PANEL_MENU,ctrl.conditions);ctrl.adminMenuItemHeadline=getAdminMenuItemsHeadline;// exposed for testing purposes
ctrl.getAdminMenuItems=getAdminMenuItems;ctrl.getMenuSectionItems=getMenuSectionItems;// ---
/**
     * Get filter conditions for the menu
     *
     * @param {Object} appConfig - application config
     *
     * @return {Array}           - conditions to be applied
     *
     * Note: unfortunately this one is not easily testable
     * because of the rolecheck using its own `me` :(
     */function getConditions(appConfig,me){var conditions=[];var isCompanyAdmin=me.roles&&roleCheck(ROLES.admin);var isTeamAdmin=me.roles&&roleCheck(ROLES.hrAdminExtended);if(appConfig.deactivatedSections.length){conditions.push('deactivatedSections');}if(!isCompanyAdmin){if(isTeamAdmin){conditions.push('teamAdmin');}else{conditions.push('companyAdmin');}}return conditions;}/**
     * Get all items for the menu
     *
     * @param  {Array} items       - menu Items
     * @param  {Array} conditions  - conditions
     * @return {Array}             - admin menu items
     *
     * @tested
     */function getAdminMenuItems(items,conditions){return _.reduce(items,function(menu,menuItem){menuItem.sections=getMenuSectionItems(menuItem.sections,conditions);if(menuItem.sections.length){menu.push(menuItem);}return menu;},[]);}/**
     * Get the available admin menu sub sections
     *
     * @param  {Array}        collection      - menu sub items
     * @param  {Array|String} filterOrFilters - menu sub items
     * @return {Array}                        - Admin menu items
     *
     * @tested
     */function getMenuSectionItems(collection,filterOrFilters){if(filterOrFilters instanceof Array){filterOrFilters.forEach(function(filterName){collection=collection.filter(filterFns[filterName]);});}else{collection=collection.filter(filterFns[filterOrFilters]);}return collection;}/**
     * Filter the admin menu by deactivated sections
     *
     * @param  {Object}  menuItem - Menu item data
     * @return {Boolean}          - Indication if this section should
     *                              be part of the menu or not
     * @private
     */function _filterByDeactivateSections(menuItem){return appConfig.deactivatedSections.some(function(result){return menuItem.link.split('.')[2]!==result.deactivatedSection.name;});}/**
     * Filter the admin menu by hr admin role
     *
     * @param  {Object}  menuItem - Menu item data
     * @return {Boolean}          - Indication if this section should
     *                              be part of the menu or not
     * @private
     */function _filterByCompanyAdminRole(menuItem){var menuItemLink=menuItem.link.split('.')[2];return menuItemLink!=='download'&&menuItemLink!=='integrations';}/**
       * Filter the admin menu by team admin role
       *
       * @param  {Object}  menuItem - Menu item data
       * @return {Boolean}          - Indication if this section should
       *                              be part of the menu or not
       * @private
       */function _filterByTeamAdminRole(menuItem){var menuItemLink=menuItem.link.split('.')[2];return menuItemLink!=='organization'&&menuItemLink!=='scores'&&menuItemLink!=='stats'&&menuItemLink!=='privacy'&&menuItemLink!=='quickFeedback'&&menuItemLink!=='teams'&&menuItemLink!=='trainings'&&menuItemLink!=='departments'&&menuItemLink!=='integrations';}/**
       * change headline base on role
       *
       * @param item
       * @returns {*}
       */function getAdminMenuItemsHeadline(item){var isCompanyAdmin=this.me.roles&&roleCheck(ROLES.admin);var isTeamAdmin=this.me.roles&&roleCheck(ROLES.hrAdminExtended);if(!isCompanyAdmin&&isTeamAdmin){return item.headlineExtendedHrAdmin||item.headline;}else{return item.headline;}}}module.exports=controller;});
